import { useMutation } from 'react-query';
import { CreatePeerGroup, PeerGroup } from './peerGroupTypes';
import { createPeerGroup } from './peerGroupService';
import { modifyError } from 'utils/error-modifer-utils';
import { toast } from 'react-toastify';

type Props = {
    onError?: (error: Error) => void;
    onSuccess?: (data: PeerGroup) => void;
};

export const useCreatePeerGroup = ({
    onSuccess = () => {},
    onError = () => {},
}: Props) => {
    const onErrorModified = (error: any) => {
        const errors = modifyError(error?.response?.data);
        if (errors) {
            for (const err of errors) {
                toast.error(err);
            }
        } else {
            toast.error('Internal error, please contact administrator');
        }

        if (onError) {
            onError(error);
        }
    };
    const mutation = useMutation(
        async (request: CreatePeerGroup) => await createPeerGroup(request),
        {
            onSuccess,
            onError: onErrorModified,
        }
    );

    return {
        mutate: mutation.mutate,
        isLoading: mutation.isLoading,
        error: mutation.error,
    };
};
